/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function PageLoader(elem) {
        Behaviors.init(PageLoader, this, arguments);


        var $thisElem = this.$elem;

        var animationItem = $('.PageLoader-overlay_animation_content_item');

        // $thisElem.addClass("PageLoader--start_heading_animation");
        var $window = $(window);
        if ($('.PageLoader').length > 0) {
            $window.scroll(function() {    
                var scroll = $window.scrollTop();
                if (scroll >= 100) {
                    $('.PageLoader').addClass("PageLoader--remove_animation");
                }
            });
        }

        
        

        var animationDone = (animationItem.length * 1.5) + '000';
        setTimeout(function() {
            $('.PageLoader-overlay_animation_content').addClass("PageLoader-overlay_animation_content--animation_done");
         }, animationDone);

    }
    Behaviors.inherit(PageLoader, Behaviors.Behavior);
    PageLoader.QUERY = "[data-page-loader-par]";
    Behaviors.register_behavior(PageLoader);
    module.PageLoader = PageLoader;
    return module;
}(window.jQuery, window.Behaviors));